










export default {
    name: 'BaseCard',
    components: {},
    props: {
    },
    data() {
        return {};
    },
    methods: {},
};
